export class AddFreeTrialParser {
  public static getPageHeaderInfo = (step: number) => {
    switch (step) {
      case 1:
        return {
          title: 'Choose your package',
          nextStep: '',
        };
      default:
        return { title: '', nextStep: '' };
    }
  };
}
